import { ref } from 'vue'
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

interface Toast {
    id: number
    message: string
    type: 'success' | 'error' | 'info' | 'warning'
}

const toasts = ref<Toast[]>([])
let idCounter = 0

export default function () {
    const addToast = (message: string, type: Toast['type'] = 'info') => {
        const id = idCounter++
        toasts.value.push({ id, message, type })
        setTimeout(() => removeToast(id), 3000) // Auto-remove after 3 seconds

        toast[type](message)
    }

    const removeToast = (id: number) => {
        toasts.value = toasts.value.filter((toast) => toast.id !== id)
    }

    return {
        success: (message: string) => addToast(message, 'success'),
        error: (message: string) => addToast(message, 'error'),
        info: (message: string) => addToast(message, 'info'),
        warning: (message: string) => addToast(message, 'warning')
    }
}
